export interface WatermarkIdentity {
  traceCode: string;
}

export const WATERMARK_STYLE_ID = "deepmox-video-watermark-style";
export const WATERMARK_OVERLAY_ID = "deepmox-video-watermark-overlay";
